import { makeAutoObservable, runInAction } from "mobx";
import agent from "../api/agent";
import { store } from "./store";
import { Pagination, PagingParams } from "../models/pagination";
import {
  IBrandData,
  IProductCategory,
  ProductCategory,
} from "../models/product";
import { toast } from "react-toastify";
import { IImalURl, ITicketItem, TicketForm } from "../models/tickets";

export default class TicketStore {
  loading = false;
  loadingInitial = "";
  dashLoadingInitial = "";
  pagination: Pagination | null = null;
  pagingParams = new PagingParams();
  //   predicate = new Map().set("all", true);
  categories: ProductCategory[] = [];
  categoryList: IProductCategory[] | null = [];
  brandsList: IBrandData[] | null = [];
  vendorTicketItemList: ITicketItem[] = [];
  vendorUnresolvedTicketItemList: ITicketItem[] = [];
  vendorResolvedTicketItemList: ITicketItem[] = [];

  constructor() {
    makeAutoObservable(this);

    // reaction(
    //   () => this.predicate.keys(),
    //   () => {
    //     this.pagingParams = new PagingParams();
    //     this.activityRegistry.clear();
    //     this.loadActivities();
    //   }
    // );
  }

  setLoading = (x: boolean) => {
    this.loading = x;
  };

  getVendorTickets = async (searchTerm : string) => {
    this.loadingInitial = "loading";
    try {
      const response = await agent.Tickets.getVendorTickets(searchTerm);
      // console.log("response", response);
      if (response.isSuccessful) {
        if (response.data) {
          runInAction(() => {
            this.vendorTicketItemList = response.data;
            this.vendorUnresolvedTicketItemList = response.data.filter(
              (item: { status: string; }) => {
                return item.status === "Pending";
              }
            );
            this.vendorResolvedTicketItemList = response.data.filter((item: { status: string; }) => {
              return item.status !== "Pending";
            });
          });
        }
      } else toast.info(response.responseMessage);
      this.loadingInitial = "";
      return response;
    } catch (error) {
      this.loadingInitial = "";
      var error1 = "Error fetching data";
      throw error1;
    }
  };

  addTicket = async (creds: TicketForm) => {
    this.loadingInitial = "loading";
    try {
      const response = await agent.Tickets.createTicket(creds);
      if (response.isSuccessful) {
        runInAction(() => (this.loadingInitial = ""));
        return response;
      } else
        runInAction(() => {
          this.loadingInitial = "";
          toast.info(response.responseMessage);
        });
    } catch (error) {
      this.loadingInitial = "";
      throw error;
    }
  };

  getUrl = async (creds: IImalURl) => {
    this.loadingInitial = "loading";
    try {
      const response = await agent.Tickets.createUrl(creds.postedFilebase64);
      if (response.isSuccessful) {
        // console.log(response);
        // runInAction(() => (this.loadingInitial = ""));
        return response;
      } else {
        const err = "Couldn't upload image";
        throw err;
      }
    } catch (error) {
      // console.log(error);
      this.loadingInitial = "";
      throw error;
    }
  };
}
